var _rect, _rect2, _path, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemLayoutRightPriceTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 58,
    viewBox: "0 0 118 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 58,
    rx: 5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 16,
    width: 49,
    height: 4,
    rx: 1.5,
    fill: "#B4B3B3",
    stroke: "#939393"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.364 12.7529V14.2129H102.612V12.7529H103.364ZM103.271 20.7266V22.0352H102.524V20.7266H103.271ZM104.009 19.1494C104.009 18.9606 103.97 18.7962 103.892 18.6562C103.817 18.513 103.693 18.3844 103.521 18.2705C103.348 18.1533 103.117 18.0443 102.827 17.9434C102.41 17.7969 102.046 17.6325 101.733 17.4502C101.424 17.2646 101.183 17.0368 101.011 16.7666C100.841 16.4932 100.757 16.153 100.757 15.7461C100.757 15.3457 100.848 14.999 101.03 14.7061C101.216 14.4131 101.473 14.1868 101.802 14.0273C102.131 13.8678 102.515 13.7881 102.954 13.7881C103.293 13.7881 103.597 13.8385 103.867 13.9395C104.141 14.0404 104.373 14.1885 104.565 14.3838C104.757 14.5791 104.904 14.82 105.005 15.1064C105.109 15.3896 105.161 15.7152 105.161 16.083H103.989C103.989 15.8747 103.965 15.6891 103.916 15.5264C103.87 15.3604 103.802 15.2204 103.711 15.1064C103.62 14.9893 103.509 14.8997 103.379 14.8379C103.252 14.776 103.107 14.7451 102.944 14.7451C102.713 14.7451 102.523 14.7891 102.373 14.877C102.223 14.9616 102.113 15.0788 102.041 15.2285C101.973 15.3783 101.938 15.5492 101.938 15.7412C101.938 15.9268 101.974 16.0895 102.046 16.2295C102.118 16.3695 102.24 16.4964 102.412 16.6104C102.588 16.721 102.829 16.8333 103.135 16.9473C103.555 17.097 103.918 17.2646 104.224 17.4502C104.533 17.6325 104.771 17.8587 104.937 18.1289C105.106 18.3958 105.19 18.7327 105.19 19.1396C105.19 19.5596 105.093 19.916 104.897 20.209C104.705 20.502 104.435 20.7249 104.087 20.8779C103.742 21.0277 103.34 21.1025 102.881 21.1025C102.591 21.1025 102.303 21.0651 102.017 20.9902C101.733 20.9121 101.476 20.7852 101.245 20.6094C101.014 20.4336 100.83 20.2008 100.693 19.9111C100.557 19.6182 100.488 19.2601 100.488 18.8369H101.67C101.67 19.0908 101.704 19.3024 101.772 19.4717C101.841 19.641 101.934 19.7744 102.051 19.8721C102.168 19.9697 102.298 20.0397 102.441 20.082C102.588 20.1243 102.734 20.1455 102.881 20.1455C103.125 20.1455 103.33 20.1048 103.496 20.0234C103.665 19.9388 103.792 19.8216 103.877 19.6719C103.965 19.5189 104.009 19.3447 104.009 19.1494Z",
    fill: "#3A3A3A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 26.5,
    width: 93,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 37.5,
    width: 63,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 57,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLayoutRightPriceTop);
export default __webpack_public_path__ + "static/media/ItemLayoutRightPriceTop.99a829829de376d33682f05831849a7d.svg";
export { ForwardRef as ReactComponent };